export const en = {
  login: {
    TITLE: 'Login',
    EMAIL: { TEXT: 'Email', PLACEHOLDER: 'Email Address' },
    PASSWORD: { TEXT: 'Password', PLACEHOLDER: '**********' },
    RECOVER: { TEXT: 'Forgot my password' },
  },
  'password-recovery': {
    TITLE: 'Password Recovery',
    SUCCESS: {
      SUMMARY: 'Email sent',
      DETAIL: 'Check your email and follow the instructions',
    },
  },
  roles: {
    ADMIN: 'Administrator',
    SELLER: 'Seller',
    ESTIMATOR: 'Estimator',
  },
  strings: {
    SUMMARY: 'Summary',
    LOGOUT_SUCCESS: 'Logged out successfully',
    PROFILE: 'Profile',
    HOME: 'Home',
    DASHBOARD: 'Dashboard',
    CALENDAR: 'Calendar',
    USERS: 'Users',
    ARTICLES: 'Materials',
    CATEGORIES: 'Categories',
    TYPES: 'Types',
    METRICS: 'Units of measure',
    RM: 'Goods Receipt',
    PURCHASE_ORDERS: 'Purchase Orders',
    INVENTORY: 'Inventory',
    HISTORY: 'Kardex',
    RECEPTION: 'Receptions',
    SUPPLIERS: 'Suppliers',
    WELCOME_USER: 'Welcome {attribute}!',
    CITY_NOT_FOUND: "Can't find a city, add it",
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: 'Are you sure you want to continue? This action cannot be undone.',
    },
    ARE_YOU_SURE_APPLIED: {
      TITLE: '{attribute}',
      TEXT: 'By applying this output it will have a unit cost of {attribute}',
    },
    ARE_YOU_SURE_CANCELLED: {
      TITLE: '{attribute}',
      TEXT: 'Cancelling the purchase order {attribute} will not affect any operation/activity related to this purchase order',
    },
    MODAL: {
      ADD: 'Add {attribute}',
      EDIT: 'Edit {attribute}',
      APPLIED: 'Apply {attribute}',
      SHOW: 'View {attribute}',
      RECEIVE: 'Receive transfer {attribute}',
      PROFILE: 'My profile',
    },
    SOMETHING_WENT_WRONG: 'Oops! Something went wrong',
    CRUD_HELPER: '{attribute} successfully',
    SUBTITLE_SUMMARY: 'A summary of your {attribute}',
    SEARCH: 'Search',
    ORDER_BY: 'Order by',
    NO_DATA_TO_DISPLAY: 'No data to display',
    LOCATIONS: 'Locations',
    LOCATION_DESTINATION: 'Destination location',
    OUT: 'Output',
    INVITATIONS: 'Invitations',
    COMMENTS: 'Comments',
    ATTACHED: 'Attachments',
    BI: 'Business Intelligence',
    SMTP_PASSWORD_REPLACE:
      'If a password for the mail service already exists, it will be replaced if a new one is entered',
  },
  filters: {
    TITLE: 'Filters',
  },
  actions: {
    LOGOUT: 'Log out',
    CANCEL: 'Cancel',
    CANCELLED: 'Cancelled',
    CLOSE: 'Close',
    ADD: 'Add',
    ACCEPT: 'Accept',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    EXPORT: 'Export',
    IMPORT: 'Import',
    CHOOSE: 'Select',
    ACTIVATE: 'Activate',
    DETAIL: 'Detail',
    ADDED: 'Saved',
    UPDATED: 'Updated',
    DOWNLOADED: 'Downloaded | Download',
    DELETED: 'Deleted',
    SEE: 'View {attribute}',
    UPLOAD: 'Upload {attribute}',
    NEW: 'New {attribute}',
    APPROVE: 'Approve',
    'IN-TRANSIT': 'In transit',
    PRINT: 'Print',
    ADD_ARTICLE: 'Add article',
    RECOVER: 'Recover',
    APPLIED: 'Applied',
    APPLY: 'Apply',
    ENTRY: 'Entry',
    OUT: 'Output',
    INACTIVE: 'Inactivate',
    SHOW_STATUS: 'View status',
    SEND: 'Send',
    RECEIVED: 'Received',
    RECEIVE: 'Receive',
    DUPLICATE: 'Duplicate',
    SEND_EMAIL: 'Send email',
  },
  settings: {
    TITLE: 'Settings',
    THEME: 'Theme',
    THEME_MODE: { LIGHT: 'Light', DARK: 'Dark' },
    LANG: 'Language',
  },
  locale: {
    ES: 'Spanish',
    EN: 'English',
  },
  dashboard: {
    INVITATIONS_RECEIVED: 'Invitations received',
    INVITATIONS_SEND_ON_TIME: 'Sent on time',
    INVITATIONS_NOT_SEND: 'Not sent',
    INVITATIONS_SENT_WRONG_TIME: 'Sent late',
    TOP_LEADS: 'Top Clients',
    SUMMARY_LEADS: 'Client Summary',
    ON_TIME: 'On time',
    NOT_SENT: 'Not sent',
    WRONG_TIME: 'Late',
    WON_VS_TOTALS: 'Won vs received',
  },
  users: {
    MODEL: 'User | Users',
    PASSWORD: 'Password',
    PASSWORD_CONFIRM: 'Confirm password',
  },
  invitations: {
    MODEL: 'Invitation | Invitations',
    NEW: 'New Invitation',
    CRITERIA: 'Criteria',
  },
  categories: {
    MODEL: 'Category | Categories',
  },
  locations: {
    MODEL: 'Location | Locations',
  },
  comments: {
    MODEL: 'Follow-up | Follow-ups',
    ESTIMATION_COMMENT: 'Estimation follow-up',
    ESTIMATION_SELLER: 'Seller follow-up',
  },
  calendars: {
    TITLE: 'Deadline Calendar',
  },
  'follow-ups': {
    MODEL: 'Follow-up | Follow-ups',
  },
  columns: {
    INDICATOR: 'Indicator',
    USER: 'User',
    PRODUCT: 'Product',
    NAME: 'Name',
    PRICE: 'Price',
    STATUS: 'Status',
    CREATED_AT: 'Creation date',
    DATE: 'Date',
    AMOUNT: 'Amount',
    CURRENCY: 'Currency',
    MXN: 'MXN',
    USD: 'USD',
    ACTIONS: 'Actions',
    FOLIO: 'Folio',
    LAST_NAME: 'Last name',
    EMAIL: 'Email | Email addresses',
    ROL: 'Role',
    TITLE: 'Title',
    DESCRIPTION: 'Description',
    CATEGORY: 'Category',
    ID: 'ID',
    ARTICLE_NAME: 'Article name',
    ARTICLE: 'Article',
    QUANTITY: 'Quantity {attribute}',
    CONTACT_NAME: 'Contact',
    CONTACT_EMAIL: 'Email',
    CONTACT_PHONE: 'Number',
    COUNTRY: 'Country',
    PHONE: 'Phone',
    CUSTOMER: 'Customer',
    PROJECT: 'Project',
    SQ_FEET: 'Square feet | Size | SF',
    LOCATION: 'Location',
    DELIVERY_DATE: 'Delivery date',
    PRIORITY: 'Priority',
    SELLER: 'Seller | Sellers',
    LEAD: 'Lead | Leads | Client',
    STATE: 'State',
    DWS: 'DWS',
    TO_REVIEW: 'Reviewed',
    SHEET: 'Sheet',
    PSS: 'PSS',
    JSS: 'JSS',
    MPER: 'MPER',
    JF: 'JF',
    QTE: 'QTE',
    DRME: 'DRME',
    FOLLOW_UP: 'Follow up',
    CITY: 'City',
    ESTIMATOR: 'Estimator',
    JOST: 'Jost | J',
    STRUCTURE: 'Structure | S',
    MISC: 'Misc | M',
    LAYER: 'Sheet | L',
    SMTP_PASSWORD: 'Password for mail service',
    SUBJECT: 'Subject',
    COMMENTS: 'Comments',
    ATTACHMENTS: 'Attachments',
  },
  status: {
    ACTIVED: 'Active',
    DELETED: 'Deleted',
    INACTIVED: 'Inactive',
    REQUESTED: 'In process',
    PENDING: 'Pending',
    APPLIED: 'Applied',
    DONE: 'Completed',
    DRAFTED: 'Draft',
    CANCELLED: 'Cancelled',
    IN_PROCESS: 'Processing',
    SENT_ON_TIME: 'Sent on time',
    RECEIVE: 'Receive',
    RECEIVED: 'Received',
    APPROVE: 'Approve',
    APPROVED: 'Approved',
    IN_TRANSIT: 'In transit',
    SEND: 'Send',
    SENT: 'Sent',
    SENT_TIME: 'Sent AT',
    SENT_WRONG_TIME: 'Sent FT',
    WON: 'Won',
    LOST: 'Lost',
    EXPIRED: 'Expired',
    HOT: 'Hot',
  },
  priority: {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
  },
  validation: {
    MIN_ONE_EMAIL: 'You must include at least one email',
    ACCEPTED: 'The {attribute} must be accepted.',
    ACCEPTED_IF: 'The {attribute} must be accepted when {other} is {value}.',
    ACTIVE_URL: 'The {attribute} is not a valid URL.',
    AFTER: 'The {attribute} must be a date after {date}.',
    AFTER_OR_EQUAL: 'The {attribute} must be a date after or equal to {date}.',
    ALPHA: 'The {attribute} must only contain letters.',
    ALPHA_DASH:
      'The {attribute} must only contain letters, numbers, dashes and underscores.',
    ALPHA_NUM: 'The {attribute} must only contain letters and numbers.',
    ARRAY: 'The {attribute} must be an array.',
    BEFORE: 'The {attribute} must be a date before {date}.',
    BEFORE_OR_EQUAL:
      'The {attribute} must be a date before or equal to {date}.',
    BETWEEN: {
      NUMERIC: 'The {attribute} must be between {min} and {max}.',
      FILE: 'The {attribute} must be between {min} and {max} kilobytes.',
      STRING: 'The {attribute} must be between {min} and {max} characters.',
      ARRAY: 'The {attribute} must have between {min} and {max} items.',
    },
    BOOLEAN: 'The {attribute} field must be true or false.',
    CONFIRMED: 'The {attribute} confirmation does not match.',
    CURRENT_PASSWORD: 'The password is incorrect.',
    DATE: 'The {attribute} is not a valid date.',
    DATE_EQUALS: 'The {attribute} must be a date equal to {date}.',
    DATE_FORMAT: 'The {attribute} does not match the format {format}.',
    DECLINED: 'The {attribute} must be declined.',
    DECLINED_IF: 'The {attribute} must be declined when {other} is {value}.',
    DIFFERENT: 'The {attribute} and {other} must be different.',
    DIGITS: 'The {attribute} must be {digits} digits.',
    DIGITS_BETWEEN: 'The {attribute} must be between {min} and {max} digits.',
    DIMENSIONS: 'The {attribute} has invalid image dimensions.',
    DISTINCT: 'The {attribute} field has a duplicate value.',
    EMAIL: 'The {attribute} must be a valid email address.',
    ENDS_WITH: 'The {attribute} must end with one of the following: {values}.',
    ENUM: 'The selected {attribute} is invalid.',
    EXISTS: 'The selected {attribute} is invalid.',
    FILE: 'The {attribute} must be a file.',
    FILLED: 'The {attribute} field must have a value.',
    GT: {
      NUMERIC: 'The {attribute} must be greater than {value}.',
      FILE: 'The {attribute} must be greater than {value} kilobytes.',
      STRING: 'The {attribute} must be greater than {value} characters.',
      ARRAY: 'The {attribute} must have more than {value} items.',
    },
    GTE: {
      NUMERIC: 'The {attribute} must be greater than or equal to {value}.',
      FILE: 'The {attribute} must be greater than or equal to {value} kilobytes.',
      STRING:
        'The {attribute} must be greater than or equal to {value} characters.',
      ARRAY: 'The {attribute} must have {value} items or more.',
    },
    IMAGE: 'The {attribute} must be an image.',
    IN: 'The selected {attribute} is invalid.',
    IN_ARRAY: 'The {attribute} field does not exist in {other}.',
    INTEGER: 'The {attribute} must be an integer.',
    IP: 'The {attribute} must be a valid IP address.',
    IPV4: 'The {attribute} must be a valid IPv4 address.',
    IPV6: 'The {attribute} must be a valid IPv6 address.',
    JSON: 'The {attribute} must be a valid JSON string.',
    LT: {
      NUMERIC: 'The {attribute} must be less than {value}.',
      FILE: 'The {attribute} must be less than {value} kilobytes.',
      STRING: 'The {attribute} must be less than {value} characters.',
      ARRAY: 'The {attribute} must have less than {value} items.',
    },
    LTE: {
      NUMERIC: 'The {attribute} must be less than or equal to {value}.',
      FILE: 'The {attribute} must be less than or equal to {value} kilobytes.',
      STRING:
        'The {attribute} must be less than or equal to {value} characters.',
      ARRAY: 'The {attribute} must not have more than {value} items.',
    },
    MAC_ADDRESS: 'The {attribute} must be a valid MAC address.',
    MAX: {
      NUMERIC: 'The {attribute} must not be greater than {max}.',
      FILE: 'The {attribute} must not be greater than {max} kilobytes.',
      STRING: 'The {attribute} must not be greater than {max} characters.',
      ARRAY: 'The {attribute} must not have more than {max} items.',
    },
    MIMES: 'The {attribute} must be a file of type: {values}.',
    MIMETYPES: 'The {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'The {attribute} must be at least {min}.',
      FILE: 'The {attribute} must be at least {min} kilobytes.',
      STRING: 'The {attribute} must be at least {min} characters.',
      ARRAY: 'The {attribute} must have at least {min} items.',
    },
    MULTIPLE_OF: 'The {attribute} must be a multiple of {value}.',
    NOT_IN: 'The selected {attribute} is invalid.',
    NOT_REGEX: 'The {attribute} format is invalid.',
    NUMERIC: 'The {attribute} must be a number.',
    PASSWORD: 'The password is incorrect.',
    PRESENT: 'The {attribute} field must be present.',
    PROHIBITED: 'The {attribute} field is prohibited.',
    PROHIBITED_IF:
      'The {attribute} field is prohibited when {other} is {value}.',
    PROHIBITED_UNLESS:
      'The {attribute} field is prohibited unless {other} is in {values}.',
    PROHIBITS: 'The {attribute} field prohibits {other} from being present.',
    REGEX: 'The {attribute} format is invalid.',
    REQUIRED: 'The {attribute} field is required.',
    REQUIRED_ARRAY_KEYS:
      'The {attribute} field must contain entries for: {values}.',
    REQUIRED_IF: 'The {attribute} field is required when {other} is {value}.',
    REQUIRED_UNLESS:
      'The {attribute} field is required unless {other} is in {values}.',
    REQUIRED_WITH:
      'The {attribute} field is required when {values} is present.',
    REQUIRED_WITH_ALL:
      'The {attribute} field is required when {values} are present.',
    REQUIRED_WITHOUT:
      'The {attribute} field is required when {values} is not present.',
    REQUIRED_WITHOUT_ALL:
      'The {attribute} field is required when none of {values} are present.',
    SAME: 'The {attribute} and {other} must match.',
    SIZE: {
      NUMERIC: 'The {attribute} must be {size}.',
      FILE: 'The {attribute} must be {size} kilobytes.',
      STRING: 'The {attribute} must be {size} characters.',
      ARRAY: 'The {attribute} must contain {size} items.',
    },
    STARTS_WITH:
      'The {attribute} must start with one of the following: {values}.',
    STRING: 'The {attribute} must be a string.',
    TIMEZONE: 'The {attribute} must be a valid timezone.',
    UNIQUE: 'The {attribute} has already been taken.',
    UPLOADED: 'The {attribute} failed to upload.',
    URL: 'The {attribute} must be a valid URL.',
    UUID: 'The {attribute} must be a valid UUID.',
    PASSWORD_EQUALS: 'Passwords should be equals.',
    ATTRIBUTES: {},
  },
}
